import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';
import { Button, Typography } from '@sequelae/lore-core';
import { useNavigationMode } from '../../contexts/NavigationModeContext';
import { NavigationModeToggle } from '../../components/NavigationModeToggle';
import { NavigationTestButtons } from '../../components/NavigationTestButtons';
import '../../styles/shared-styles.css';
import '../../styles/about.css';
import '../../styles/ios-styles.css';

export const AboutIOS = () => {
  const navigate = useNavigate();
  const { isNativeMode } = useNavigationMode();

  const menuItems = [
    {
      id: 'privacy',
      title: 'Privacy Policy',
      url: 'https://www.lore.co/privacypolicy',
      path: '/about-ios/privacy',
    },
    {
      id: 'terms',
      title: 'Terms of Use',
      url: 'https://www.lore.co/terms',
      path: '/about-ios/terms',
    },
  ];

  const handleNativePush = (path: string) => {
    console.log(`🚀 CommunicationBridge.openMFEModule: MenuMFE → ${path}`);
    // CommunicationBridge handles all fallbacks internally (postMessage, routing, etc.)
    CommunicationBridge.openMFEModule({
      url: 'https://menu-mfe-nonprod.lorehealthcare.io',
      scope: 'MenuMFE',
      module: 'MenuMFE',
      path: path,
    });
  };

  const handleMenuItemClick = (item: { id: string; title: string; url: string; path: string }) => {
    if (isNativeMode) {
      // Use CommunicationBridge.openMFEModule to open Terms/Privacy in new webview
      handleNativePush(item.path);
    } else {
      // Use React Router navigation in legacy web-like mode
      navigate(item.path);
    }
  };

  return (
    <div className="screen ios">
      <div className="shared-container">
        <div className="ios-container">
          <header className="ios-header">
            {!isNativeMode && (
              <Button onClick={() => navigate(-1)} className="ios-back-button" variant="text">
                <svg
                  width="13"
                  height="21"
                  viewBox="0 0 13 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 2L3 10.5L10 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <Typography variant="body" className="ml-auto">
                  Menu
                </Typography>
              </Button>
            )}
            <Typography variant="h1" className="ios-header-title">
              About
            </Typography>
            <div
              style={{
                padding: '0 var(--spacing-space-2)',
                marginLeft: 'auto',
              }}
            >
              <NavigationModeToggle />
            </div>
          </header>

          <div
            className="ios-card"
            style={{
              margin: 'var(--spacing-space-8) var(--spacing-space-4) var(--spacing-space-4)',
            }}
          >
            {menuItems.map((item, index) => (
              <Button
                key={item.id}
                onClick={() => handleMenuItemClick(item)}
                className="ios-list-item"
                style={{
                  borderBottom:
                    index !== menuItems.length - 1 ? '0.5px solid rgba(0, 0, 0, 0.15)' : 'none',
                  justifyContent: 'space-between',
                }}
              >
                <Typography variant="body" className="ios-list-item-text">
                  {item.title}
                </Typography>
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0"
                >
                  <path d="M0.5 1L6.5 6.5L0.5 12" stroke="#C7C7CC" strokeWidth="1.5" />
                </svg>
              </Button>
            ))}
          </div>
          <div className="navigation-test-spacer">
            <NavigationTestButtons />
          </div>
        </div>
      </div>
    </div>
  );
};
